import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setInfoDetailed} from "../../store/openBets/openBets.slice";

export const connectAccountStatementTable = (wrappedProps) => (component) => {
    function mapStateToProps (state) {
        return {
            user: state.user,
            timeSettings: state.timeSettings,
        };
    }

    function mapDispatchToProps (dispatch) {
        const actions = {
            setInfoDetailed,
        };

        return {actions: bindActionCreators(actions, dispatch)};
    }

    return connect(mapStateToProps, mapDispatchToProps)(component);
};
